import { useState, useEffect } from 'react';
import { elements } from '../data';
import { getAnimationClass } from './../utils';

import Game from './images/1.jpg';

export default function NormElements({ onComplete, numberOfAttempts }) {
  const [showIntroP, setShowIntroP] = useState(false);
  const [showDebitCreditView, setShowDebitCreditView] = useState(false);
  const [fadeOutFirstSection, setFadeOutFirstSection] = useState(false);
  const [hideFirstSection, setHideFirstSection] = useState(false);
  
  const [showSecondP, setShowSecondP] = useState(false);
  const [showImage1, setShowImage1] = useState(false);
  const [fadeOutSecondSection, setFadeOutSecondSection] = useState(false);
  const [hideSecondSection, setHideSecondSection] = useState(false);
  
  const [showThirdSectionIntroP, setShowThirdSectionIntroP] = useState(false);
  const [showThirdSectionH2, setShowThirdSectionH2] = useState(false);
  const [visibleElements, setVisibleElements] = useState(0);
  const [fadeOutThirdSection, setFadeOutThirdSection] = useState(false);
  const [hideThirdSection, setHideThirdSection] = useState(false);
  
  const [showFinalP, setShowFinalP] = useState(false);
  const [showFinalImage, setShowFinalImage] = useState(false);

  useEffect(() => {
    const timeouts = [];
    let currentTime = 0;
    
    currentTime += 500;
    timeouts.push(setTimeout(() => setShowIntroP(true), currentTime));
    
    currentTime += 4000;
    timeouts.push(setTimeout(() => setShowDebitCreditView(true), currentTime));

    currentTime += 5000;
    timeouts.push(setTimeout(() => {
      setFadeOutFirstSection(true);
      setShowSecondP(true);
    }, currentTime));
    
    currentTime += 3000;
    timeouts.push(setTimeout(() => setHideFirstSection(true), currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => setShowImage1(true), currentTime));
    
    currentTime += 3000;
    timeouts.push(setTimeout(() => {
      setFadeOutSecondSection(true);
      setShowThirdSectionIntroP(true);
    }, currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => setHideSecondSection(true), currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => setShowThirdSectionH2(true), currentTime));
    
    elements.forEach((_, index) => {
      currentTime += 500;
      timeouts.push(setTimeout(() => setVisibleElements(index + 1), currentTime));
    });
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => {
      setFadeOutThirdSection(true);
      setShowFinalP(true);
    }, currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => setHideThirdSection(true), currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => setShowFinalImage(true), currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => onComplete?.(), currentTime));
    
    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Normal Balances</h1>
      
      <div className="animation-section">
        {!hideFirstSection && (
          <div className={`animation-content ${fadeOutFirstSection ? 'animation-content--exiting' : ''}`}>
            <p className={getAnimationClass(showIntroP, fadeOutFirstSection)}>
              Accounting can be tricky if you don't know <b>normal balances</b>: the rules that tell whether an account normally carries a debit or credit balance. 
            </p>
            
            <div className={`transition-debit-credit-view ${getAnimationClass(showDebitCreditView, fadeOutFirstSection)}`}>
              <div className="debit-credit-container">Debit Balance <span>(left side)</span></div>
              <div className="debit-credit-container">Credit Balance <span>(right side)</span></div>
            </div>
          </div>
        )}

        {showSecondP && !hideSecondSection && (
          <div className={`animation-content ${fadeOutSecondSection ? 'animation-content--exiting' : ''}`}>
            <p className={getAnimationClass(showSecondP, fadeOutSecondSection)}>
              This sorting exercise will help you quickly remember these rules. <br/>
              In the exercise, you'll sort accounts to their correct normal balance. <b>The faster and more accurately you sort, the more points you earn!</b>
            </p>
            
            {showImage1 && (
              <img 
                src={Game} 
                alt="Normal Game" 
                className={`transition-image ${getAnimationClass(showImage1, fadeOutSecondSection)}`}
              />
            )}
          </div>
        )}

        {showThirdSectionIntroP && !hideThirdSection && (
          <div className={`animation-content ${fadeOutThirdSection ? 'animation-content--exiting' : ''}`}>
            <p className={getAnimationClass(showThirdSectionIntroP, fadeOutThirdSection)}>
              You'll start with sorting the <b>5 Elements of the financial statements</b>, The building blocks for all accounts.
            </p>
            
            {showThirdSectionH2 && (
              <h2 className={getAnimationClass(showThirdSectionH2, fadeOutThirdSection)}>
                The 5 Elements
              </h2>
            )}
            
            {showThirdSectionH2 && (
              <div className={`transition-elements-container ${getAnimationClass(visibleElements > 0, fadeOutThirdSection)}`}>
                {elements.map((item, index) => (
                  <div 
                    key={index}
                    className={`transition-element ${getAnimationClass(index < visibleElements)}`}
                    style={{ backgroundColor: item.color }}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {showFinalP && (
          <div className="animation-content">
            <p className={getAnimationClass(showFinalP)}>
              And you'll have <b>up to {numberOfAttempts} attempts</b>, so no pressure. By the end, you'll feel more confident and prepared. You've got this!
            </p>
            
            {showFinalImage && (
              <img 
                src={Game} 
                alt="Normal Game" 
                className={`transition-image big-margin ${getAnimationClass(showFinalImage)}`}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
}